import { getCountryCallingCode, parsePhoneNumberFromString, type CountryCode } from 'libphonenumber-js';

/**
 * Numeros de telephone a l'ecran (2026-09-30).
 *
 * La base stocke la forme NATIONALE sans separateur et le PAYS a cote ;
 * l'ecran affiche le numero au format de son pays (« 06 12 34 56 78 »,
 * « 0468 32 91 48 ») et laisse saisir avec ou sans espaces, avec ou sans
 * indicatif : c'est le serveur qui normalise. Les regles par pays
 * viennent de libphonenumber, comme cote serveur.
 */

/** Les pays proposes a la saisie : la France d'abord, puis les voisins. */
export const PAYS_TELEPHONE: { code: CountryCode; libelle: string }[] = [
  { code: 'FR', libelle: 'France' },
  { code: 'BE', libelle: 'Belgique' },
  { code: 'CH', libelle: 'Suisse' },
  { code: 'LU', libelle: 'Luxembourg' },
  { code: 'DE', libelle: 'Allemagne' },
  { code: 'ES', libelle: 'Espagne' },
  { code: 'IT', libelle: 'Italie' },
  { code: 'GB', libelle: 'Royaume-Uni' },
  { code: 'PT', libelle: 'Portugal' },
  { code: 'NL', libelle: 'Pays-Bas' },
];

/** « +33 » pour FR. */
export function indicatif(pays: string): string {
  try {
    return `+${getCountryCallingCode(pays as CountryCode)}`;
  } catch {
    return '';
  }
}

/** Le numero stocke, au format de son pays, pour un champ de saisie (sans indicatif). */
export function telephonePourSaisie(numero: string | null | undefined, pays?: string | null): string {
  if (!numero) return '';
  const parse = parsePhoneNumberFromString(numero, (pays ?? 'FR') as CountryCode);
  return parse ? parse.formatNational() : numero;
}

/**
 * Le numero stocke, au format de son pays. Un numero qui ne se lit pas
 * (donnee ancienne, pays inconnu) s'affiche tel quel plutot que vide.
 */
export function formaterTelephone(numero: string | null | undefined, pays?: string | null): string {
  if (!numero) return '';
  const parse = parsePhoneNumberFromString(numero, (pays ?? 'FR') as CountryCode);
  if (!parse) return numero;
  // Hors de France, l'indicatif accompagne le numero : « 0468 32 91 48 »
  // se lirait comme un numero francais.
  return (pays ?? 'FR') === 'FR'
    ? parse.formatNational()
    : `${parse.formatNational()} (${indicatif(pays ?? 'FR')})`;
}
